/*
 * HOMEPAGE 2023 : IMAGE SLIDER CAROUSEL
 */
jQuery(document).ready(
	function($) {
		function IMAGESLIDER( thisInstance ) {
			console.log('IMAGESLIDER V1 loaded');

			this.instance = thisInstance;
			this.sliderClass = '.imageslider';
			this.sliderCount = 0;
			this.slideWidth = $( this.sliderClass).width();
			this.stageWidth = 0;
			this.currentMargin = $( this.sliderClass + '__slides').css('margin-left', 0);
			this.changeCount = 1;
			this.animationStatus = 'completed';
			this.animationSpeed = 1000;
			this.autoSlide = true;
			this.autoSlideTime = 5000;

			this.eventListeners();
			this.setImageSliderSize();
			this.createPaginationDots();
			this.setDotInstate();
			// Stops the image flicker on page load
			$( this.instance ).css( 'visibility', 'visible' );
		}

		IMAGESLIDER.prototype.eventListeners = function () {
			const self = this; // eslint-disable-line consistent-this
			$( window ).resize(
				function () {
					self.setImageSliderSize();
					self.createPaginationDots();
					self.setDotInstate();
					self.changeSlides( 'backtoone' );
				}
			);
			// On next button click...
			self.instance.on( 'click', self.sliderClass + '__slides--next',
				function () {
					self.countSlides();
					if ( self.sliderCount != self.changeCount ) {
						self.countSlides('reset');
						self.changeSlides('next');
					} else {
						self.countSlides( 'reset' );
						self.changeSlides( 'backtoone' );
					}
				}
			);
			// On prev button click...
			self.instance.on( 'click', self.sliderClass + '__slides--prev',
				function () {
					self.countSlides();
					if ( 1 != self.changeCount ) {
						self.countSlides('reset');
						self.changeSlides('prev');
					} else {
						self.countSlides( 'reset' );
						self.changeSlides( 'gotoend' );
					}
				}
			);
			// On pause / play button click...
			self.instance.on( 'click', self.sliderClass + '__toprow--autoslide',
				function () {
					console.log( 'AUTO SLIDE BUTTON CLICK' )
					self.changeAutoSlide();
				}
			);
			// Auto slider - Change slides every x seconds
			window.setInterval(
				function() {
					if ( true == self.autoSlide ) {
						self.countSlides();

						if ( self.sliderCount != self.changeCount ) {
							self.countSlides( 'reset' );
							self.changeSlides( 'next' );
						} else {
							self.countSlides( 'reset' );
							self.changeSlides( 'backtoone' );
						}
					}
				},
				self.autoSlideTime
			);
			// On mouse over image slider, disable auto-slide
			self.instance.on( 'mouseover', self.sliderClass + '__slides',
				function() {
					self.changeAutoSlide( true )
				}
			);
			// On mouse over image in slide, increase opacity
			self.instance.on( 'mouseover', self.sliderClass + '__slides--slidebox',
				function() {
					$( this ).children().addClass('imageslider__opacity--full');
				}
			);
			// On mouse out image in slide, decrease opacity
			self.instance.on( 'mouseout', self.sliderClass + '__slides--slidebox',
				function() {
					$( this ).children().removeClass('imageslider__opacity--full');
				}
			);
		};
		/**
		 * Change the status of the auto slide features
		 *
		 * @param { boolean } mouseOver - Whether the status change is a result of a mouse over event
		 * @return { void } - New status of the auto slide (playing or paused)
		 */
		IMAGESLIDER.prototype.changeAutoSlide = function ( mouseOver = false ) {
			const self = this; // eslint-disable-line consistent-this
			const buttonElement = self.instance.find( self.sliderClass + '__toprow--autoslide' );
			const slidesContainer = $( '#imageslider_slides' );

			function stopSliding() {
				self.autoSlide = false;
				buttonElement.attr( 'data-state', 'paused' );
				buttonElement.attr( 'aria-label', 'Resume auto-sliding' );
				buttonElement.find( 'span' ).text( 'Resume auto-sliding' );
				buttonElement.find( 'i' ).removeClass( 'fa-circle-pause' ).addClass( 'fa-circle-play' );
				slidesContainer.attr( 'aria-live', 'polite' );
			}

			function startSliding() {
				self.autoSlide = true;
				buttonElement.attr( 'data-state', 'playing' );
				buttonElement.attr( 'aria-label', 'Pause auto-sliding' );
				buttonElement.find( 'span' ).text( 'Pause auto-sliding' );
				buttonElement.find( 'i' ).removeClass( 'fa-circle-play' ).addClass( 'fa-circle-pause' );
				slidesContainer.attr( 'aria-live', 'off' );
			}

			if ( true == mouseOver ) {
				stopSliding();
			} else {
				switch ( buttonElement.attr( 'data-state' ) ) {
					case 'playing':
						stopSliding();
						break;
					case 'paused':
						startSliding();
						break;
					default:
				}
			}
		}
		/**
		 * Slide the carousel, updating the dot pagination
		 *
		 * @param { int } margin - The amount of pixels to 'slide' the carousel by
		 * @return { void } - The new position of the carousel slides
		 */
		IMAGESLIDER.prototype.animateSlides = function ( margin ) {
			const self = this; // eslint-disable-line consistent-this
			self.instance.find( self.sliderClass + '__slides' ).animate(
				{
					'margin-left': margin + 'px'
				},
				self.animationSpeed,
				function () {
					self.animationStatus = 'completed';
				}
			);
			self.setDotInstate();
		};
		/**
		 * Change the slide(s) dependent on direction
		 *
		 * @param { string } direction - The direction to move the carousel
		 * @param { any } element - The DOM element of the pagination dot (optional)
		 * @return { void } - The new position of the carousel slides
		 */
		IMAGESLIDER.prototype.changeSlides = function ( direction, element ) {
			const self = this; // eslint-disable-line consistent-this
			if ( 'completed' == self.animationStatus ) {
				let calculateMargin = '';
				self.currentMargin = self.instance.find( self.sliderClass + '__slides' ).css( 'margin-left' );
				self.animationStatus = 'in progress';
				self.countSlides();
				if ( 'prev' == direction ) {
					if (
						1 != self.changeCount
					) {
						calculateMargin = self.slideWidth - parseInt( self.currentMargin.replace('-', '').replace('px', ''));
						self.changeCount--;
						self.animateSlides( calculateMargin );
					} else {
						self.animationStatus = 'completed';
					}
				}
				if ( 'next' == direction ) {
					if (
						self.sliderCount != self.changeCount
					) {
						calculateMargin = self.slideWidth + parseInt( self.currentMargin.replace('-', '').replace('px', ''));
						self.changeCount++;
						self.animateSlides( '-' + calculateMargin );
					} else {
						self.animationStatus = 'completed';
					}
				}
				if ( 'dot' == direction ) {
					const dotCount = element.attr( 'data-count' );
					if ( self.changeCount != dotCount ) {
						calculateMargin = ( dotCount * self.slideWidth ) - self.slideWidth; // eslint-disable-line no-extra-parens
						self.changeCount = dotCount;
						self.animateSlides( '-' + calculateMargin );
					} else {
						self.animationStatus = 'completed';
					}
				}
				if ( 'backtoone' == direction ) {
					self.changeCount = 1;
					self.animateSlides( 0 );
				}
				if ( 'gotoend' == direction ) {
					self.changeCount = self.sliderCount;
					calculateMargin = ( self.sliderCount * self.slideWidth ) - self.slideWidth; // eslint-disable-line no-extra-parens
					self.animateSlides( '-' + calculateMargin );
				}
				self.countSlides( 'reset' );
			}
		};
		/**
		 * Count the carousel slide(s)
		 *
		 * @param { string } mode - Change the mode of the function (optional)
		 * @return { void } - The new slide count
		 */
		IMAGESLIDER.prototype.countSlides = function ( mode ) {
			const self = this; // eslint-disable-line consistent-this
			if ( 'reset' == mode ) {
				self.sliderCount = 0;
			} else {
				let count = 0;
				self.instance.find( self.sliderClass + '__slides--slide' ).each(
					function () {
						count++;
					}
				);
				self.sliderCount = false == self.isMobileWidth() ? count / 3 : count;
			}
		};

		IMAGESLIDER.prototype.createPaginationDots = function () {
			const self = this; // eslint-disable-line consistent-this
			self.instance.find( self.sliderClass + '__pagination--dotcontainer' ).html('');
			self.countSlides();
			if ( self.sliderCount ) {
				for ( let i = 1; i <= self.sliderCount; i++ ) {
					self.instance.find( self.sliderClass + '__pagination--dotcontainer' ).append('<button class="imageslider__pagination--dotcontainer-dot" type="button" data-count="' + i + '" role="tab" aria-label="3 slides, group ' + i + '" aria-selected="false" aria-controls="imageslider_slides"><i class="fas fa-circle"></i></button>');
				}
			}
			self.countSlides( 'reset' );
			// Event listener - On dot click...
			self.instance.find( self.sliderClass + '__pagination--dotcontainer-dot' ).click(
				function () {
					self.changeSlides( 'dot', $(this) );
				}
			);
		};
		/**
		 * Set the instate of the active pagination dot
		 *
		 * @return { void } - The new dot instate
		 */
		IMAGESLIDER.prototype.setDotInstate = function () {
			const self = this; // eslint-disable-line consistent-this
			const count = self.changeCount;
			self.instance.find( self.sliderClass + '__pagination--dotcontainer-dot' ).each(
				function () {
					// Clear the instates
					$( this ).find( 'i' ).css( 'color', '#898D8F' ).parent().attr( 'aria-selected', false );
					// Add the instate
					if ( count == $( this ).attr( 'data-count' ) ) {
						$( this ).find( 'i' ).css( 'color', '#038663' ).parent().attr( 'aria-selected', true );
					}
				}
			);
		};
		/**
		 * Check if the viewport is mobile device size (below 991 px)
		 *
		 * @return { boolean } - Is the viewport mobile device size
		 */
		IMAGESLIDER.prototype.isMobileWidth = function () {
			let result = false;
			if ( window.innerWidth <= 991 ) {
				result = true;
			}
			return result;
		}
		/**
		 * Calculate, and set the width of the slides and the carousel
		 *
		 * @return { void } - The new widths of the slides and carousel
		 */
		IMAGESLIDER.prototype.setImageSliderSize = function () {
			const self = this; // eslint-disable-line consistent-this
			let slideWidth = 0;

			self.slideWidth = self.instance.width();
			self.countSlides();
			self.stageWidth = ( self.slideWidth * self.sliderCount ) + 13; // eslint-disable-line no-extra-parens

			self.instance.find( self.sliderClass + '__slides' ).width( self.stageWidth );

			slideWidth = false == self.isMobileWidth() ? ( self.slideWidth / 3 ) - 11 : self.slideWidth; // eslint-disable-line no-extra-parens

			self.instance.find( self.sliderClass + '__slides--slide' ).width( slideWidth );

			self.countSlides( 'reset' );
		};
		// Instantiate this JS for each instance of the 'imageslider' class (if present)
		if ( $( '.imageslider' ).length > 0 ) {
			$( '.imageslider' ).each(
				function () {
					new IMAGESLIDER( $( this ) ) // eslint-disable-line no-new
				}
			)
		}
	}
);